import { render } from "./ProcessIndicator.vue?vue&type=template&id=3f808cf2"
import script from "./ProcessIndicator.vue?vue&type=script&lang=js"
export * from "./ProcessIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrii/Documents/Projects/optometry-academy-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__